import { Injectable } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class CategoryEssentialsService {

  constructor(public fb: UntypedFormBuilder) { }


  returnSubsectionObject(data, childCollapsed?) {
    let obj = this.fb.group({
      ChildItemDescription: new UntypedFormControl(data?.ChildItemDescription),
      ChildItemID: new UntypedFormControl(data?.ChildItemID),
      ChildItemLabel: new UntypedFormControl(data?.ChildItemLabel),
      ChildItemTitle: new UntypedFormControl(data?.ChildItemTitle),
      ListOrder: new UntypedFormControl(data?.ListOrder),
      ParentItemID: new UntypedFormControl(data?.ParentItemID),
      ResponseValueTypeID: new UntypedFormControl(data?.ResponseValueTypeID),
      childValue: new UntypedFormControl(''),
      groupNo: new UntypedFormControl(data?.groupNo ? data.groupNo : 1),
     // files: new UntypedFormArray(data?.Attachments ? data.Attachments : []),
      imageValue: new UntypedFormControl(data?.FileURL),
      total: new UntypedFormControl(data?.total),
      assessmentResponseID: new UntypedFormControl(0),
      Responses:  data?.Responses && data?.Responses?.length ? this.populateChildResponses(data?.Responses)
      : new UntypedFormArray([]),
      ResponseId: new UntypedFormControl('-'),
      MaxRangeValue: new UntypedFormControl(this.getMaxRange(data?.Responses, data?.ResponseValueTypeID)),
      isChildCollapsed: new UntypedFormControl(childCollapsed),
      isHidden: new UntypedFormControl(false),
      ChildItemGroupNumber: new UntypedFormControl(data?.ChildItemGroupNumber),
      ReceiverItemID: new UntypedFormControl(data?.ReceiverItemID),
      SenderItemID: new UntypedFormControl(data?.SenderItemID),
      IsChildItemResponseIdAvailable: new UntypedFormControl(data?.IsChildItemResponseIdAvailable),
      ParentSenderItemID: new UntypedFormControl(data?.ParentSenderItemID),
      IsChildItemResponseRequired: new UntypedFormControl(data?.IsChildItemResponseRequired),
      files: data?.Attachments && data.Attachments.length
        ? this.populateFiles(data?.Attachments)
        : new UntypedFormArray([]),
      ItemFormat: new UntypedFormControl(data?.ItemFormat),
      isDynamicallyValidated: new UntypedFormControl(true),
    })
    return obj;
  }

  public populateChildItems(childData, IsCategoryExpiry?: any) {
    let childArray = new UntypedFormArray([]);
    if (childData) {
      childData.forEach(element => {
        childArray.push(
          this.fb.group({
            ChildItemDescription: new UntypedFormControl(element.ChildItemDescription),
            ChildItemID: new UntypedFormControl(element.ChildItemID),
            ChildItemLabel: new UntypedFormControl(element.ChildItemLabel),
            ChildItemTitle: new UntypedFormControl(element.ChildItemTitle),
            ListOrder: new UntypedFormControl(element.ListOrder),
            ParentItemID: new UntypedFormControl(element.ParentItemID),
            ResponseValueTypeID: new UntypedFormControl(element.ResponseValueTypeID),
            childValue: new UntypedFormControl(''),
            groupNo: new UntypedFormControl(1),
            total: new UntypedFormControl(element.TotalCount),
            assessmentResponseID: new UntypedFormControl(0),
            Responses:  element.Responses && element.Responses.length ? this.populateChildResponses(element?.Responses)
            : new UntypedFormArray([]),
            ResponseId: new UntypedFormControl('-'),
            MaxRangeValue: new UntypedFormControl(this.getMaxRange(element?.Responses, element?.ResponseValueTypeID)),
            isChildCollapsed: new UntypedFormControl(false),
            isHidden: new UntypedFormControl(false),
            ChildItemGroupNumber: new UntypedFormControl(element?.ChildItemGroupNumber),
            SenderItemID: new UntypedFormControl(element?.SenderItemID),
            ReceiverItemID: new UntypedFormControl(element?.ReceiverItemID),
            IsChildItemResponseIdAvailable: new UntypedFormControl(element?.IsChildItemResponseIdAvailable),
            ParentSenderItemID: new UntypedFormControl(element?.ParentSenderItemID),
            IsChildItemResponseRequired: new UntypedFormControl(IsCategoryExpiry == 0 ? element?.IsChildItemResponseRequired : false),
            files: element.Attachments && element.Attachments.length
              ? this.populateFiles(element.Attachments)
              : new UntypedFormArray([]),
            imageValue: new UntypedFormControl(element?.FileURL),
            ItemFormat: new UntypedFormControl(element?.ItemFormat),
            isDynamicallyValidated: new UntypedFormControl(true),
          })
        );
      });
    }
    return childArray;
  }

  populateFiles(files) {
    const filesArray = new UntypedFormArray([]);
    files?.forEach((element) => {
      filesArray?.push(
        this.fb.group({
          Author: new UntypedFormControl(element?.Author),
          fileId: new UntypedFormControl(
            element?.AssessmentResponseAttachmentID
              ? element?.AssessmentResponseAttachmentID
              : element.fileId
          ),
          fileURL: new UntypedFormControl(
            element?.FileURL ? element?.FileURL : element?.fileURL
          ),
          UpdateDate: new UntypedFormControl(element?.UpdateDate),
          fileName: new UntypedFormControl(
            element?.FileName ? element?.FileName : element?.fileName
          ),
          byteArray: new UntypedFormControl(),
        })
      );
    });
    return filesArray;
  }

  public getMaxRange(element, typeID) {
    let max = 0;
    if (element) {
      max = typeID === 3 ? element[0]?.MaxRangeValue : null;
    }
    return max;
  }

  public populateChildResponses(childResponses) {
    let responseFormArray = new UntypedFormArray([]);
    if (childResponses) {
      childResponses.forEach(element => {
        responseFormArray.push(
          this.fb.group({
            AllowMultipleGroups: new UntypedFormControl(element?.AllowMultipleGroups),
            Description: new UntypedFormControl(element?.Description),
            displayChildItem: new UntypedFormControl(element?.displayChildItem),
            KeyCodes: new UntypedFormControl(element?.KeyCodes),
            Label: new UntypedFormControl(element?.Label),
            ListOrder: new UntypedFormControl(element?.ListOrder),
            ChildItemGroupNumber: new UntypedFormControl(element?.ChildItemGroupNumber),
            ResponseId: new UntypedFormControl(element?.ResponseId),
            Value: new UntypedFormControl(element?.Value),
            dropdownChar: new UntypedFormControl(element?.dropdownChar),
            MaxRangeValue: new UntypedFormControl(element?.MaxRangeValue),
            childValue: new UntypedFormControl(element?.Value),
            hideResponse:  new UntypedFormControl(null),

          })
        );
      });
    }
    return responseFormArray;
  }

  /**
   *
   * @param status Assesment status
   * @param role Role of the user
   */
  public assessmentEditPermissions(status, role) {
    let isShowSubmitSave = false;
    let isPermission = false;
    switch (role) {
      case 'Helper RO':
        if (status === 'In Progress') {
          isPermission = true;
        }
        if (status === 'Complete') {
          isPermission = true;
        }
        if (status === 'Submitted') {
          isPermission = true;
        }
        if (status === 'Returned') {
          isPermission = true;
        }
        if (status === 'Approved') {
          isPermission = true;
        }
        if (status === 'Incomplete') {
          isPermission = true;
        }
        if (status === 'Email Sent') {
          isPermission = true;
        }
        break;
      case 'Helper RW':
      case "Reviewer" :
      case 'Assessor':
        if (status === 'In Progress') {
          isShowSubmitSave = true;
          isPermission = false;
        }
        if (status === 'Complete') {
          isShowSubmitSave = true;
          isPermission = false;
        }
        if (status === 'Submitted') {
          isShowSubmitSave = false;
          isPermission = true;
        }
        if (status === 'Returned') {
          isShowSubmitSave = true;
          isPermission = false;
        }
        if (status === 'Approved') {
          isShowSubmitSave = true;
          isPermission = true;
        }
        if (status === 'Incomplete') {
          isShowSubmitSave = true;
          isPermission = false;
        }
        if (status === 'Email Sent') {
          isShowSubmitSave = false;
          isPermission = true;
        }
        break;

      case 'Supervisor':
        if (status === 'Submitted') {
          isShowSubmitSave = false;
          isPermission = true;
        }
        if (status === 'Complete') {
          isShowSubmitSave = true;
          isPermission = false;
        }
        if (status === 'Returned') {
          isShowSubmitSave = true;
          isPermission = false;
        }
        if (status === 'Approved') {
          isShowSubmitSave = false;
          isPermission = true;
        }
        if (status === 'Incomplete') {
          isShowSubmitSave = true;
          isPermission = false;
        }
        if (status === 'Email Sent') {
          isShowSubmitSave = false;
          isPermission = true;
        }
        if (status === 'In Progress') {
          isShowSubmitSave = true;
          isPermission = false;
        }
        break;

      case 'Supervisor With History':
        if (status === 'Submitted') {
          isShowSubmitSave = false;
          isPermission = true;
        }
        if (status === 'Complete') {
          isShowSubmitSave = true;
          isPermission = false;
        }
        if (status === 'Returned') {
          isShowSubmitSave = true;
          isPermission = false;
        }
        if (status === 'Approved') {
          isShowSubmitSave = false;
          isPermission = true;
        }
        if (status === 'Incomplete') {
          isShowSubmitSave = true;
          isPermission = false;
        }
        if (status === 'Email Sent') {
          isShowSubmitSave = false;
          isPermission = true;
        }
        if (status === 'In Progress') {
          isShowSubmitSave = true;
          isPermission = false;
        }
        break;

      case 'Super Admin':
        if (status === 'Submitted') {
          isShowSubmitSave = false;
          isPermission = true;
        }
        if (status === 'Complete') {
          isShowSubmitSave = true;
          isPermission = false;
        }
        if (status === 'Returned') {
          isShowSubmitSave = true;
          isPermission = false;
        }
        if (status === 'Approved') {
          isShowSubmitSave = true;
          isPermission = false;
        }
        if (status === 'Incomplete') {
          isShowSubmitSave = true;
          isPermission = false;
        }
        if (status === 'Email Sent') {
          isShowSubmitSave = false;
          isPermission = true;
        }
        if (status === 'In Progress') {
          isShowSubmitSave = true;
          isPermission = false;
        }
        break;

      case 'Org Admin':
        if (status === 'Approved') {
          isShowSubmitSave = true;
          isPermission = true;
        }
        if (status === 'Complete') {
          isShowSubmitSave = true;
          isPermission = false;
        }
        if (status === 'Returned') {
          isShowSubmitSave = true;
          isPermission = false;
        }
        if (status === 'Incomplete') {
          isShowSubmitSave = true;
          isPermission = false;
        }
        if (status === 'Submitted') {
          isShowSubmitSave = true;
          isPermission = true;
        }
        if (status === 'Email Sent') {
          isShowSubmitSave = false;
          isPermission = true;
        }
        if (status === 'In Progress') {
          isShowSubmitSave = true;
          isPermission = false;
        }
        break;

      case 'Organization Admin RO':
        if (status === 'Approved') {
          isPermission = true;
        }
        if (status === 'Complete') {
          isPermission = true;
        }
        if (status === 'Returned') {
          isPermission = true;
        }
        if (status === 'Incomplete') {
          isPermission = true;
        }
        if (status === 'Submitted') {
          isPermission = true;
        }
        if (status === 'Email Sent') {
          isPermission = true;
        }
        if (status === 'In Progress') {
          isPermission = true;
        }
        break;

      case 'Organization Admin RW':
        if (status === 'Approved') {
          isShowSubmitSave = true;
          isPermission = false;
        }
        if (status === 'Complete') {
          isShowSubmitSave = true;
          isPermission = false;
        }
        if (status === 'Returned') {
          isShowSubmitSave = true;
          isPermission = false;
        }
        if (status === 'Incomplete') {
          isShowSubmitSave = true;
          isPermission = false;
        }
        if (status === 'Submitted') {
          isShowSubmitSave = false;
          isPermission = true;
        }
        if (status === 'Email Sent') {
          isShowSubmitSave = false;
          isPermission = true;
        }
        if (status === 'In Progress') {
          isShowSubmitSave = true;
          isPermission = false;
        }
        break;
      case 'Praed':
        if (status === 'Submitted') {
          isShowSubmitSave = false;
          isPermission = true;
        }
        if (status === 'Complete') {
          isShowSubmitSave = true;
          isPermission = false;
        }
        if (status === 'Returned') {
          isShowSubmitSave = true;
          isPermission = false;
        }
        if (status === 'Approved') {
          isShowSubmitSave = false;
          isPermission = true;
        }
        if (status === 'Incomplete') {
          isShowSubmitSave = true;
          isPermission = false;
        }
        if (status === 'Email Sent') {
          isShowSubmitSave = false;
          isPermission = true;
        }
        if (status === 'In Progress') {
          isShowSubmitSave = true;
          isPermission = false;
        }
        break;

      case 'External User RW':
        if (status === 'In Progress') {
          isShowSubmitSave = true;
          isPermission = false;
        }
        if (status === 'Complete') {
          isShowSubmitSave = true;
          isPermission = false;
        }
        if (status === 'Submitted') {
          isShowSubmitSave = false;
          isPermission = true;
        }
        if (status === 'Returned') {
          isShowSubmitSave = true;
          isPermission = false;
        }
        if (status === 'Approved') {
          isShowSubmitSave = true;
          isPermission = true;
        }
        if (status === 'Incomplete') {
          isShowSubmitSave = true;
          isPermission = false;
        }
        if (status === 'Email Sent') {
          isShowSubmitSave = false;
          isPermission = true;
        }
        break;

      case 'External User RO':
        if (status === 'In Progress') {
          isPermission = true;
        }
        if (status === 'Complete') {
          isPermission = true;
        }
        if (status === 'Submitted') {
          isPermission = true;
        }
        if (status === 'Returned') {
          isPermission = true;
        }
        if (status === 'Approved') {
          isPermission = true;
        }
        if (status === 'Incomplete') {
          isPermission = true;
        }
        if (status === 'Email Sent') {
          isPermission = true;
        }
        break;
    }

    return {
      showButtons: isShowSubmitSave,
      permission: isPermission
    };
  }

  public assessmentDeletePermissions(status, role) {
    switch (role) {
      case 'Helper RO':
        if (status === 'In Progress') {
          return false;
        }
        if (status === 'Complete') {
          return false;
        }
        if (status === 'Submitted') {
          return false;
        }
        if (status === 'Returned') {
          return false;
        }
        if (status === 'Approved') {
          return false;
        }
        if (status === 'Email Sent') {
          return false;
        }
        break;
      case 'Helper RW':
      case "Reviewer" :
      case 'Assessor':
        if (status === 'In Progress') {
          return true;
        }
        if (status === 'Complete') {
          return false;
        }
        if (status === 'Submitted') {
          return false;
        }
        if (status === 'Returned') {
          return true;
        }
        if (status === 'Approved') {
          return false;
        }
        if (status === 'Email Sent') {
          return true;
        }
        break;

      case 'Praed':
      case 'Supervisor':
        if (status === 'Submitted') {
          return false;
        }
        if (status === 'Complete') {
          return true;
        }
        if (status === 'In Progress') {
          return true;
        }
        if (status === 'Returned') {
          return true;
        }
        if (status === 'Approved') {
          return false;
        }
        if (status === 'Email Sent') {
          return true;
        }
        break;

      case 'Supervisor With History':
        if (status === 'Submitted') {
          return false;
        }
        if (status === 'Complete') {
          return true;
        }
        if (status === 'In Progress') {
          return true;
        }
        if (status === 'Returned') {
          return true;
        }
        if (status === 'Approved') {
          return false;
        }
        if (status === 'Email Sent') {
          return true;
        }
        break;

      case 'Super Admin':
        if (status === 'Submitted') {
          return true;
        }
        if (status === 'Complete') {
          return true;
        }
        if (status === 'In Progress') {
          return true;
        }
        if (status === 'Returned') {
          return true;
        }
        if (status === 'Approved') {
          return true;
        }
        if (status === 'Email Sent') {
          return true;
        }
        break;

      case 'Org Admin':
        if (status === 'Approved') {
          return true;
        }
        if (status === 'Complete') {
          return true;
        }
        if (status === 'In Progress') {
          return true;
        }
        if (status === 'Returned') {
          return true;
        }
        if (status === 'Submitted') {
          return true;
        }
        if (status === 'Email Sent') {
          return true;
        }
        break;

      case 'Organization Admin RO':
        if (status === 'Approved') {
          return false;
        }
        if (status === 'Complete') {
          return false;
        }
        if (status === 'In Progress') {
          return false;
        }
        if (status === 'Returned') {
          return false;
        }
        if (status === 'Submitted') {
          return false;
        }
        if (status === 'Email Sent') {
          return false;
        }
        break;

      case 'Organization Admin RW':
        if (status === 'Approved') {
          return true;
        }
        if (status === 'Complete') {
          return true;
        }
        if (status === 'In Progress') {
          return true;
        }
        if (status === 'Returned') {
          return true;
        }
        if (status === 'Submitted') {
          return true;
        }
        if (status === 'Email Sent') {
          return true;
        }
        break;

      case 'External User RW':
        if (status === 'In Progress') {
          return true;
        }
        if (status === 'Complete') {
          return false;
        }
        if (status === 'Submitted') {
          return false;
        }
        if (status === 'Returned') {
          return true;
        }
        if (status === 'Approved') {
          return false;
        }
        if (status === 'Email Sent') {
          return true;
        }
        break;

      case 'External User RO':
        if (status === 'In Progress') {
          return false;
        }
        if (status === 'Complete') {
          return false;
        }
        if (status === 'Submitted') {
          return false;
        }
        if (status === 'Returned') {
          return false;
        }
        if (status === 'Approved') {
          return false;
        }
        if (status === 'Email Sent') {
          return false;
        }
        break;
    }
  }

  public responseBehaviorNames(propertyName: any, behaviorName: any, status: any) {
    switch (propertyName) {
      case 'Need':
        if (status === 'Secondary') {
          if (behaviorName === 'Background') {
            return 'None';
          } else {
            return 'Background';
          }
        } else {
          if (behaviorName === 'Focus') {
            return 'None';
          } else {
            return 'Focus';
          }
        }
        break;
      case 'Strength':
        if (status === 'Secondary') {
          if (behaviorName === 'Use') {
            return 'None';
          } else {
            return 'Use';
          }
        } else {
          if (behaviorName === 'Build') {
            return 'None';
          } else {
            return 'Build';
          }
        }
        break;
      case 'Exposure':
        if (behaviorName === 'Underlying') {
          return 'None';
        } else {
          return 'Underlying';
        }
        break;
      case 'Support':
        if (status === 'Secondary') {
          if (behaviorName === 'Background') {
            return 'None';
          } else {
            return 'Background';
          }
        } else {
          if (behaviorName === 'Focus') {
            return 'None';
          } else {
            return 'Focus';
          }
        }
        break;
      case 'Support Need':
        if (status === 'Secondary') {
          if (behaviorName === 'Background') {
            return 'None';
          } else {
            return 'Background';
          }
        } else {
          if (behaviorName === 'Focus') {
            return 'None';
          } else {
            return 'Focus';
          }
        }
        break;
      case 'Support Resource':
        if (status === 'Secondary') {
          if (behaviorName === 'Use') {
            return 'None';
          } else {
            return 'Use';
          }
        } else {
          if (behaviorName === 'Build') {
            return 'None';
          } else {
            return 'Build';
          }
        }
        break;
      case 'Support Exposure':
        if (behaviorName === 'Underlying') {
          return 'None';
        } else {
          return 'Underlying';
        }
        break;
      case 'Support Unmodifiable':
        if (behaviorName === 'Underlying') {
          return 'None';
        } else {
          return 'Underlying';
        }
        break;
      case 'Unmodifiable':
        if (behaviorName === 'Underlying') {
          return 'None';
        } else {
          return 'Underlying';
        }
        break;
      case 'Opinion':
        if (behaviorName === 'Consider') {
          return 'None';
        } else {
          return 'Consider';
        }
        break;
      case 'Circumstance':
        if (behaviorName === 'Consider') {
          return 'None';
        } else {
          return 'Consider';
        }
        break;
      case 'Preference':
        if (behaviorName === 'Consider') {
          return 'None';
        } else {
          return 'Consider';
        }
        break;
      case 'Goal':
        if (status === 'Secondary') {
          if (behaviorName === 'Achieved') {
            return 'None';
          } else {
            return 'Achieved';
          }
        } else {
          if (behaviorName === 'Ongoing') {
            return 'None';
          } else {
            return 'Ongoing';
          }
        }
        break;
    }
  }

  /**
   * Function to populate the supports if focus id is 2
   * @param supports supportArray
   * @param assessmentDate Assessment Date to disable the supports based on Assesssment date
   * @param supportID Pass null incase of fresh assessment or support id
   * @param questionsArray QuestionCategory array
   * @param baseId Base Questionaire ID
   */
  public populateSupports(supports, assessmentDate, supportID, questionsArray?, baseId?) {
    let supportArray = new UntypedFormArray([]);
    if (supports?.length > 0) {
      if (supportID) {
        let supportObj = supports?.find(val => val.personSupportID === supportID);
        if (supportObj) {
          supportArray.push(
            this.fb.group(this.returnSupportForm(supportObj))
          );
        }
      } else {
        if (questionsArray && baseId) {
          let supportCategories = questionsArray?.filter(val => val.baseCategoryId === baseId);
          if (supportCategories.length > 0) {
            let tempSupport = [];
            supportCategories?.forEach(element => {
              if(element.supportID !=null){
                let supportObj = supports?.find(val => val.personSupportID === element.supportID);
                tempSupport.push(supportObj);
              }
            });
            supports.forEach(support => {
              let isSupportExist = tempSupport?.some(val => val.personSupportID === support?.personSupportID);

              if (!isSupportExist) {
                supportArray.push(
                  this.fb.group(this.returnSupportForm(support))
                );
              }
            });
          } else {
            supports.forEach(support => {
              supportArray.push(
                this.fb.group(this.returnSupportForm(support))
              );
            });
          }
        } else {
          supports.forEach(support => {
            supportArray.push(
              this.fb.group(this.returnSupportForm(support))
            );
          });
        }
      }

    }

    return supportArray;
  }

  returnSupportForm(support) {
    let supportObj = {
      "supportFirstName": new UntypedFormControl(support?.supportFirstName),
      "supportMiddleName": new UntypedFormControl(support?.supportMiddleName),
      "supportLastName": new UntypedFormControl(support?.supportLastName),
      "supportPhoneCode": new UntypedFormControl(support?.supportPhoneCode),
      "supportPhone": new UntypedFormControl(support?.supportPhone),
      "supportEmail": new UntypedFormControl(support?.supportEmail),
      "relationshipID": new UntypedFormControl(support?.relationshipID),
      "relationship": new UntypedFormControl(support?.relationship),
      "personSupportID": new UntypedFormControl(support?.personSupportID),
      "isCurrent": new UntypedFormControl(support?.isCurrent),
      "startDate": new UntypedFormControl(support?.startDate),
      "endDate": new UntypedFormControl(support?.endDate),
      "suffix": new UntypedFormControl(support?.suffix),
      "personID": new UntypedFormControl(support?.personID),
      "isDisable": new UntypedFormControl(support.isDisable?support.isDisable:false),
     "isRemoved" :new UntypedFormControl(support.isRemoved?support.isRemoved:false),
    }

    return supportObj;
  }

  /**
   *
   * @param isAssesmentPresent If assesment is present
   * @param personIndex PersonIndex
   * @param questionId Questionaireid
   * @param voiceId voitype id
   * @param voiceFkId voice type fkID
   * @param newAssessments assessmentObject
   * @param type save/submit
   */
    generateAssessmentSaveObject(isAssesmentPresent, personIndex, questionId, voiceId, voiceFkId, newAssessments, type, assessmentVersionNumber) {

    const assessObj = {
      AssessmentVersion: assessmentVersionNumber,
      AssessmentID: isAssesmentPresent
        ? newAssessments?.assessmentID
        : 0,
      personIndex: personIndex,
      questionnaireID: questionId,
      voiceTypeID: voiceId,
      voiceTypeFKID: voiceFkId,
      dateTaken: newAssessments
        ? moment(newAssessments.date)
          .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
          .toString()
        : new Date(),
      reasoningText: newAssessments?.note,
      assessmentReasonID: newAssessments?.assessmentReasonID,
      assessmentStatus: type,
      closeDate: newAssessments
        ? moment(newAssessments.date)
          .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
          .toString()
        : new Date(),
      eventDate: newAssessments?.eventDate
        ? moment(newAssessments.eventDate)
          .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
          .toString()
        : null,
      eventNotes: newAssessments?.eventNotes
        ? newAssessments.eventNotes
        : null,
    };
    return assessObj;
  }
public isSupportPersonIsRemoved(supports, category) {
  return (category?.FocusId == 2 && supports && supports.length > 0)
            ? supports.find(support => support.personSupportID === category?.supportID)?.isRemoved
            : false;
}
public isSupportPersonIsExpired(supports, category) {
  if (category?.FocusId !== 2 || !supports?.length) return false;
  const support = supports.find(s => s.personSupportID === category?.supportID);
  if (!support) return false;
  const isCurrent = !!support.isCurrent;
  const startDate = support.startDate ? moment(support.startDate).startOf('day') : null;
  const today = moment().startOf('day');
  const isActivated = startDate ? today.isSameOrAfter(startDate) : false;
  return !(isCurrent && isActivated);
}
}
